import React from 'react';
import PropTypes from 'prop-types';
import { Viewer } from './pacifa3d-sdk.1.2.0.es';

/**
 This component renders a panoramic view from the viewpoint of a block.
 In practice, it's the same thing as a SeatFrame, except the
 seat is automatically selected as the central one for the block.
 */
export function SeatFrame({
    seat = 'B7R7S404',
    block = 'B7',
    pacifaKey = '9DetV-LO7YJ-vwrXY',
    idFrame = 'seat-selector-frame',
}) {
    React.useEffect(() => {
        let viewer = new Viewer(idFrame, pacifaKey, {
            fewerPanoControls: true,
        });
        viewer.displaySeatPano(block, seat, viewer.containerEl);
    }, [block, pacifaKey, seat, idFrame]);
    return <div id={idFrame} />;
}

SeatFrame.propTypes = {
    /** The pacifa id, something like 9DetV-LO7YJ-vwrXY */
    pacifaKey: PropTypes.string.isRequired,
    /** The id of the block to set the viewpoint in, something like B7,
   * it depends on which pacifaKey was given.  */
    block: PropTypes.string.isRequired,
    /** The seat to set the viewer in */
    seat: PropTypes.string.isRequired,
    /** The id of the dom node to create, needs to be unique. Use it to set the size of the panoramic view in css.*/
    idFrame: PropTypes.string.isRequired,
};

export default SeatFrame;
